__turbopack_context__.v({
  "content": "xnLFXa_content",
  "layerToggle": "xnLFXa_layerToggle",
  "layerToggles": "xnLFXa_layerToggles",
  "legendContainer": "xnLFXa_legendContainer",
  "mapButton": "xnLFXa_mapButton",
  "mapContainer": "xnLFXa_mapContainer",
  "toggleTile": "xnLFXa_toggleTile",
});
